import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-content-container overflow-hidden" }
const _hoisted_2 = { class: "row justify-content-center" }
const _hoisted_3 = { class: "col-xxl-3 col-xl-6 col-sm-6" }
const _hoisted_4 = { class: "col-xxl-3 col-xl-6 col-sm-6" }
const _hoisted_5 = { class: "col-xxl-3 col-xl-6 col-sm-6" }
const _hoisted_6 = { class: "col-xxl-3 col-xl-6 col-sm-6" }
const _hoisted_7 = { class: "row justify-content-center" }
const _hoisted_8 = { class: "col-lg-8" }
const _hoisted_9 = { class: "col-lg-4" }
const _hoisted_10 = { class: "row justify-content-center" }
const _hoisted_11 = { class: "col-xxl-4 col-xl-5 col-lg-5" }
const _hoisted_12 = { class: "col-xxl-8 col-xl-7 col-lg-7" }
const _hoisted_13 = { class: "row justify-content-center" }
const _hoisted_14 = { class: "col-xxl-8 col-xl-7 col-lg-6" }
const _hoisted_15 = { class: "col-xxl-4 col-xl-5 col-lg-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RevenueGrowthChart = _resolveComponent("RevenueGrowthChart")!
  const _component_LeadConversionChart = _resolveComponent("LeadConversionChart")!
  const _component_TotalOrdersChart = _resolveComponent("TotalOrdersChart")!
  const _component_AnnualProfitChart = _resolveComponent("AnnualProfitChart")!
  const _component_BalanceOverviewChart = _resolveComponent("BalanceOverviewChart")!
  const _component_LeadsBySourceChart = _resolveComponent("LeadsBySourceChart")!
  const _component_TopPerformers = _resolveComponent("TopPerformers")!
  const _component_RecentLeads = _resolveComponent("RecentLeads")!
  const _component_SalesReportChart = _resolveComponent("SalesReportChart")!
  const _component_TopProductsBySales = _resolveComponent("TopProductsBySales")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_RevenueGrowthChart)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_LeadConversionChart)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_TotalOrdersChart)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_AnnualProfitChart)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_BalanceOverviewChart)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_LeadsBySourceChart)
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_TopPerformers)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_RecentLeads)
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_SalesReportChart)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_TopProductsBySales)
      ])
    ])
  ]))
}